import React from 'react';
const ShopPage = () => {
  const products = [{
    id: 'cookbook',
    title: 'Jemi Baby Cookbook',
    description: "Nutritious and delicious recipes for your baby's developmental stages. This comprehensive cookbook includes 30 recipes specifically designed for babies from 6 months and above.",
    price: '₦3,700',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rAkkvgbfh1SkzpzARSosJN/Jemi_Baby_Cookbook.png',
    link: 'https://selar.com/jemibabycookbook'
  }, {
    id: 'mealplanner',
    title: 'Jemi Baby Meal Planner',
    description: "Weekly meal planning made easy for busy moms. With a week of pre-planned meals, shopping lists, and preparation tips, you'll save time and ensure your baby gets a balanced diet with variety.",
    price: '₦3,200',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uDtBUFBW6Zd73xFL3XpRhA/Jemi_Baby_Meal_Planner.png',
    link: 'https://selar.com/jemibabymealplanner'
  }, {
    id: 'foodguide',
    title: 'Jemi Baby Food Guide',
    description: 'Complete guide to introducing solid foods to your baby. Learn when and how to introduce different foods, understand nutritional needs, and navigate common challenges with confidence.',
    price: '₦2,200',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1Ja1LXkpPqvN6wNKVrJ6gG/Jemi_Baby_Food_Guide.png',
    link: 'https://selar.com/jemibabyfoodguide'
  }, {
    id: 'feedingguide',
    title: 'Jemi Baby Feeding Guide',
    description: 'Expert advice on feeding schedules and techniques for babies. Learn about responsive feeding, recognizing hunger cues, and creating positive mealtime experiences for your baby.',
    price: '₦3,700',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kfXgudTvAHWbqQ59X4WrAe/Jemi_Baby_Feeding_Guide.png',
    link: 'https://selar.com/jemibabyfeedingguide'
  }, {
    id: 'fruitchart',
    title: 'Jemi Baby Alphabet Food & Fruit Chart',
    description: "Colorful chart introducing babies to foods alphabetically. Perfect for teaching food recognition and expanding your baby's palate with a variety of nutritious options.",
    price: '₦3,700',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/feu8akjKiyBuomVpGzjTba/Jemi_Baby_Food_and_Fruit_Chart.png',
    link: 'https://selar.com/jemibabychart'
  }, {
    id: 'bundle-cookbook-mealplan',
    title: 'Bundle - Meal Plan + CookBook',
    description: 'Get our popular Jemi Baby Cookbook and Meal Planner together at a special bundle price. Perfect for planning and preparing nutritious meals for your baby.',
    price: '₦6,000',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/pnEYagqiaYDtjViRXgNrX4/3.png',
    link: 'https://selar.com/jemibabybundle2'
  }, {
    id: 'bundle-foodguide-feedingguide',
    title: 'Bundle - Food Guide + Feeding Guide',
    description: 'Complete baby feeding solution combining our Food Guide and Feeding Guide. Learn when to introduce foods and how to establish healthy feeding routines.',
    price: '₦5,000',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/t2Js9cFw31C1HzgMtda8K7/4.png',
    link: 'https://selar.com/jemibabybundle1'
  }, {
    id: 'bundle',
    title: 'Complete Jemi Baby Bundle',
    description: "Get all our digital products at a special discounted price. This comprehensive package provides everything you need to confidently navigate your baby's nutrition journey from 6 months to 2 years.",
    price: '₦13,500',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mdpNuog9qCbw8mWf8MziqD/2.png',
    link: 'https://selar.com/jemibabybundle'
  }];
  return <div className="bg-cream py-12" data-id="element-458">
      <div className="container mx-auto px-4" data-id="element-459">
        <div className="text-center mb-12" data-id="element-460">
          <h1 className="text-3xl md:text-4xl font-bold text-brown mb-4" data-id="element-461">
            Shop Our Digital Products
          </h1>
          <p className="text-gray-700 max-w-2xl mx-auto" data-id="element-462">
            Our carefully crafted guides and resources to support you through
            every stage of your baby's nutrition journey.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-463">
          {products.map(product => <div key={product.id} className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300" data-id="element-464">
              <a href={product.link} target="_blank" rel="noopener noreferrer" data-id="element-465">
                <div className="p-4" data-id="element-466">
                  <img src={product.imageUrl} alt={product.title} className="w-full h-64 object-contain mx-auto" data-id="element-467" />
                </div>
              </a>
              <div className="p-6" data-id="element-468">
                <a href={product.link} target="_blank" rel="noopener noreferrer" data-id="element-469">
                  <h3 className="text-xl font-bold text-brown mb-2" data-id="element-470">
                    {product.title}
                  </h3>
                </a>
                <p className="text-gray-600 mb-4" data-id="element-471">{product.description}</p>
                <div className="flex justify-between items-center" data-id="element-472">
                  <span className="text-brown font-bold text-lg" data-id="element-473">
                    {product.price}
                  </span>
                  <a href={product.link} target="_blank" rel="noopener noreferrer" className="bg-brown text-cream px-4 py-2 rounded-full hover:bg-brown-dark transition-colors duration-300" data-id="element-474">
                    View Details
                  </a>
                </div>
              </div>
            </div>)}
        </div>
        <div className="mt-16 bg-beige p-8 rounded-lg" data-id="element-475">
          <div className="text-center" data-id="element-476">
            <h2 className="text-2xl font-bold text-brown mb-4" data-id="element-477">
              Need Help Choosing?
            </h2>
            <p className="text-gray-700 mb-6 max-w-2xl mx-auto" data-id="element-478">
              Not sure which product is right for you? Contact us for
              personalized recommendations based on your baby's age and needs.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-479">
              <a href="https://wa.me/2348065406312" target="_blank" rel="noopener noreferrer" className="bg-brown text-cream px-6 py-3 rounded-full hover:bg-brown-dark transition-colors duration-300 inline-block" data-id="element-480">
                Ask on WhatsApp
              </a>
              <a href="mailto:hello@jemibabycare.store" className="bg-white text-brown px-6 py-3 rounded-full hover:bg-gray-100 border border-brown transition-colors duration-300 inline-block" data-id="element-481">
                Email Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default ShopPage;